export default "__VITE_PUBLIC_ASSET__699ae865__"